import { render, staticRenderFns } from "./PeritVideoCallPage.vue?vue&type=template&id=8d5d3476&"
import script from "./PeritVideoCallPage.vue?vue&type=script&lang=js&"
export * from "./PeritVideoCallPage.vue?vue&type=script&lang=js&"
import style0 from "./PeritVideoCallPage.vue?vue&type=style&index=0&id=8d5d3476&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports